export class FormScore {
  ScoreSummary?: Content[] = new Array(new Content());
  TotalScore?: Content[] = new Array(new Content());
  Response?: Content[] = new Array(new Content());
  Compliance?: Content[] = new Array(new Content());
  Risk?: Content[] = new Array(new Content());
}

export class Content {
  Label?: string = '';
  Score?: any = '';
  Number?: string | number = '';
  Message?: string = '';
}

// SM-1127: Risk Form Assignment Types
export enum RiskFormAssignmentType {
  AssignToSelf = 0,
  ExistingUser = 1,
  RequestNewUser = 2
}

export interface IRiskFormAssignmentRequest {
  AssignmentType: RiskFormAssignmentType;
  OrgFormRefID: string;  // CCA OrgForm RefID - used to find/create linked Risk FormRequest
  AssignToUserRefID?: string;
  FirstName?: string;
  LastName?: string;
  Email?: string;
}

export interface IRiskFormAssignmentResponse {
  Success: boolean;
  Message: string;
}
